/* eslint-disable react-hooks/exhaustive-deps */
import { useContext, useEffect } from 'react';
import PortfolioItemCloseBlockingContext from './PortfolioItemCloseBlockingContext';
import { blockPageClose, unblockPageClose } from '@/lib/pageCloseBlocking';

const useBlockPortfolioItemCloseWhenDirty = (
  isDirty: boolean,
  savePendingChanges: () => Promise<void>,
): void => {
  const { blockPortfolioItemClose, unblockPortfolioItemClose } = useContext(
    PortfolioItemCloseBlockingContext,
  );

  useEffect(() => {
    if (isDirty) {
      const pageCloseBlockerId = blockPageClose();
      const portfolioItemCloseBlockerId =
        blockPortfolioItemClose(savePendingChanges);

      return (): void => {
        unblockPortfolioItemClose(portfolioItemCloseBlockerId);
        unblockPageClose(pageCloseBlockerId);
      };
    }
  }, [savePendingChanges, isDirty]);
};

export default useBlockPortfolioItemCloseWhenDirty;
